import { UserId } from "@a_team/models/dist/UserObject";
import { AccountId, AccountRoleAccessLevel } from "models/Account";
import { useAccountCollaborators } from "queries/accounts/collaborators/useAccountCollaborators";
import { useMemo } from "react";
import { useRootStore } from "store";

interface Params {
  userId?: UserId;
  accountId?: AccountId;
}

/**
 * Retrieves the user accessLevel based on the provided  user ID and account ID.
 * If any of the parameters are not provided, it falls back to the corresponding values from the application state.
 * @param userId - The ID of the user.
 * @param accountId - The ID of the account.
 * @returns The user's accessLevel.
 */
const useUserAccessLevelFromAccount = ({
  userId,
  accountId,
}: Params): AccountRoleAccessLevel | undefined => {
  const {
    userStore: { user },
    accountsStore: { currentAccountId },
  } = useRootStore();

  userId = userId || user?.uid;
  accountId = accountId || currentAccountId;

  const { data: collaborators } = useAccountCollaborators(accountId);

  const accessLevel = useMemo(() => {
    if (!userId || !accountId || !collaborators) {
      return;
    }

    const collaborator = collaborators.find(
      (collaborator) => collaborator?.user.id === userId
    );

    return collaborator?.accessLevel;
  }, [userId, accountId, collaborators]);

  return accessLevel;
};

export default useUserAccessLevelFromAccount;
